import(/* webpackMode: "eager" */ "/home/runner/work/monorepo/monorepo/apps/custom-made/src/app/configurator/error.tsx");
